import { useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Loader2, CheckCircle2, AlertTriangle } from "lucide-react";
import { call } from "./common";

export default function TestDialog({ initial, onClose }) {
  const [path, setPath] = useState(initial);
  const [live, setLive] = useState(false);
  const [res, setRes] = useState(null);
  const [busy, setBusy] = useState(false);
  const go = async () => { setBusy(true); setRes(await call(() => api.get("/admin/url-repair/test", { params: { path, live } }))); setBusy(false); };
  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent className="max-w-xl" data-testid="ur-test-dialog">
        <DialogHeader><DialogTitle>Test a URL</DialogTitle></DialogHeader>
        <div className="flex gap-2">
          <Input value={path} onChange={(e) => setPath(e.target.value)} placeholder="/product/old-url" className="font-mono text-xs" data-testid="ur-test-path" />
          <Button disabled={!path || busy} onClick={go} className="bg-steel text-white" data-testid="ur-test-run">{busy ? <Loader2 size={15} className="animate-spin" /> : "Test"}</Button>
        </div>
        <label className="text-xs flex items-center gap-1.5"><input type="checkbox" checked={live} onChange={(e) => setLive(e.target.checked)} data-testid="ur-test-live" />Also fetch it from the live website (acponline.co.nz)</label>
        {res && (
          <div className="text-sm space-y-2" data-testid="ur-test-result">
            <div className={`flex items-center gap-2 font-semibold ${res.ok ? "text-emerald-700" : "text-red-700"}`}>
              {res.ok ? <CheckCircle2 size={16} /> : <AlertTriangle size={16} />}{res.ok ? "OK" : res.error || (res.final_state === "live" ? "Works, but via a chain" : "Ends on a page that doesn't exist")} · status {res.code}</div>
            {res.hops.map((h, i) => <div key={i} className="font-mono text-xs break-all">{h.from} → {h.to} <span className="text-muted-foreground">({h.code}, {h.via})</span></div>)}
            <div className="text-xs">Final page: <span className="font-mono break-all">{res.final}</span> — {res.final_state}</div>
            {res.live_check && <div className="text-xs text-muted-foreground">Live site: {res.live_check.error || `HTTP ${res.live_check.status}${res.live_check.location ? ` → ${res.live_check.location}` : ""}${res.live_check.meta_refresh ? ` · permanent-redirect page → ${res.live_check.meta_refresh}` : ""}`}</div>}
          </div>)}
      </DialogContent>
    </Dialog>
  );
}
